import mutations from 'shared/helpers/vuex/result/mutations'

export default {
    ...mutations
}


// WEBPACK FOOTER //
// ./src/residential/modules/Result/vuex/mutations.js